<lib-thumbnail [isFavourite]="isFavourite" [data]="data" type="like" (action)="onFavourite()"></lib-thumbnail>

<ng-template #signUpAdTemplate>
  <app-add-home [data]="{ url: data?.source_data?.details_url }"></app-add-home>
</ng-template>
